import React, { useState, useEffect } from 'react'
import { Card } from '@/components/ui/card'
import StoryCard from "@/components/StoryCard"
import { API } from '@/api'
import type { Story } from '@/types'
import { useToast } from '@/components/ui/use-toast'
import { useNavigate } from 'react-router-dom'

const Discover = () => {
  const [stories, setStories] = useState<Story[]>([])
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState<'latest' | 'likes' | 'views'>('latest')
  const { toast } = useToast()
  const navigate = useNavigate()

  // 获取故事列表
  const fetchStories = async () => {
    setLoading(true)
    try {
      const result = await API.stories.list({
        page: 1,
        pageSize: 20,
        visibility: 'public',
        status: 'published'
      })
      setStories(result.items)
    } catch (error) {
      console.error('Failed to fetch stories:', error)
      toast({
        title: '错误',
        description: '获取故事列表失败',
        variant: 'destructive'
      })
    } finally {
      setLoading(false)
    }
  }

  // 处理排序变化
  const handleSortChange = (value: string) => {
    setSortBy(value as 'latest' | 'likes' | 'views')
    // TODO: 根据排序重新获取数据
  }

  // 首次加载时获取数据
  useEffect(() => {
    fetchStories()
  }, [])

  // 处理故事卡片点击
  const handleStoryClick = (storyId: string) => {
    navigate(`/story/${storyId}`, { 
      state: { from: 'discover' }
    })
  }

  return (
    <div className="space-y-8 w-full">
      {/* 筛选器 */}
      <div className="flex justify-end">
        <select 
          className="cute-select px-4 py-2"
          value={sortBy}
          onChange={(e) => handleSortChange(e.target.value)}
        >
          <option value="latest">最新发布</option>
          <option value="likes">最多收藏</option>
          <option value="views">最多浏览</option>
        </select>
      </div>

      {/* 加载状态 */}
      {loading && (
        <div className="text-center py-8">
          加载中...
        </div>
      )}

      {/* 故事网格 */}
      {!loading && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {stories.map(story => (
            <StoryCard 
              key={story.id}
              id={story.id}
              title={story.title}
              cover={story.coverImageUrl}
              author={story.authorId} // TODO: 需要获取作者信息
              onClick={() => handleStoryClick(story.id)}
              className="hover:scale-105 transition-transform duration-300"
            />
          ))}
        </div>
      )}

      {/* 空状态 */}
      {!loading && stories.length === 0 && (
        <div className="text-center py-12 text-gray-500">
          暂无故事
        </div>
      )}
    </div>
  )
}

export default Discover 